module.exports = __webpack_public_path__ + "img/workspace-settings.75f45a11.png";